import * as base64url from '../helpers/base64url'
import bootbox from 'bootbox'

const meta = 'signup'
window[`fnc_${meta}`] = initSignupPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})

function initSignupPage() {
    $('#rootwizard').bootstrapWizard({
        'onNext': function (tab, navigation, index) {
            var form = $($(tab).data("targetForm"))
            if (form) {
                form.addClass('was-validated');
                if (form[0].checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
            }

            if (index == 1) {
                const params = {
                    email: $('#f_email').val(),
                    _csrf: $("meta[name=_csrf]").attr("content")
                }

                $.ajax({
                    url: '/json/send-code',
                    method: 'POST',
                    data: params,
                    success: function (response) {
                        if (typeof response['error'] !== 'undefined') {
                            helpers.alert(response)
                        }
                        if (DEBUG) console.log(response)
            

                    },
                    error: function (err) {
                        helpers.alert(err)
                    }
                })
            }
        }
    });

    $('#code').keyup(function(key) {
        $('.code-error').addClass('visually-hidden')
        $('.code-next').prop('disabled', true)

        const code = $('#code').val().toString().replaceAll('-', '')

        

        if (code.length == 6) {
            const params = {
                email: $('#f_email').val(),
                code: $('#code').val(),
                _csrf: $("meta[name=_csrf]").attr("content")
            }

            $.ajax({
                url: '/json/check-code',
                method: 'POST',
                data: params,
                success: function (response) {
                    if (DEBUG) console.log(response)

                    $('.code-next').prop('disabled', false)
                    $('.code-next').trigger('click')

                },
                error: function (err) {
                    helpers.alert(err)
                    $('.code-error').removeClass('visually-hidden')
                }
            })
        }


    })

    $('.btn-register').on('click', function(e) {
        e.preventDefault()

         const params = { _csrf: $("meta[name=_csrf]").attr("content") }

        $(':input').each(function() {
            const id = $(this).attr('id')

            if (typeof id !== 'undefined' && /^f_/.test(id)) {
                params[id.replaceAll(/^f_/g, '')] = $(this).val()
            }
        })

        $.ajax({
            url: '/json/register',
            method: 'POST',
            data: params,
            success: function (response) {
                if (DEBUG) console.log(response)

                if (typeof response['error'] !== 'undefined') {
                    if (response['error'] == 'user_exists')
                        response['error'] = global.i18n.t('signup.user_exists')
                    
                    return helpers.alert(response)

                }

                window.location.href = '/enroll'

            },
            error: function (err) {
                helpers.alert(err)
            }
        })
    })

    $('.needs-validation').on('submit', function (event) {
        event.preventDefault()
        event.stopPropagation()

        // const invalid = $('#profile-form :invalid')

        // if (invalid.length > 0)
        //     return
    })

}